// import React from 'react';
// import { Link } from 'react-router-dom';
// import { LEGAL_DOCS } from '../components/pages/legal/LegalLayout';

// const REQUIRED = ['terms', 'privacy', 'antispam'];
// const OPTIONAL = ['cookie', 'marketing'];

// export default function ConsentCheckboxes({ value, onChange, disabled }) {
//   const render = (code) => {
//     const doc = LEGAL_DOCS.find(d => d.code === code);
//     if (!doc) return null;
//     const required = REQUIRED.includes(code);

//     return (
//       <label key={code} className="flex items-start gap-2 text-[13px] text-gray-600 leading-snug">
//         <input
//           type="checkbox"
//           className="mt-0.5"
//           disabled={disabled}
//           checked={!!value[code]}
//           onChange={(e) => onChange(code, e.target.checked)}
//         />
//         <span>
//           {required ? 'Я принимаю ' : 'Согласен с '}
//           <Link to={doc.path} className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">
//             {doc.label}
//           </Link>
//           {!required && ' и на получение информационных сообщений'}
//           {required && ' *'}
//         </span>
//       </label>
//     );
//   };

//   return (
//     <div className="space-y-2">
//       {REQUIRED.map(render)}
//       <div className="pt-2 border-t border-gray-100 space-y-2">
//         {OPTIONAL.map(render)}
//       </div>
//       <p className="text-[11.5px] text-gray-400 pt-1">
//         Поля со звёздочкой обязательны.
//       </p>
//     </div>
//   );
// }

import React from 'react';
import { Link } from 'react-router-dom';
import { LEGAL_DOCS } from '../components/pages/legal/LegalLayout';

export default function ConsentCheckboxes({ value, onChange, disabled }) {
  const terms   = LEGAL_DOCS.find(d => d.code === 'terms');
  const privacy = LEGAL_DOCS.find(d => d.code === 'privacy');
  const cookie  = LEGAL_DOCS.find(d => d.code === 'cookie');

  // Один чекбокс управляет сразу тремя согласиями
  const allChecked = !!(value.terms && value.privacy && value.cookie);

  const handleChange = (checked) => {
    onChange('terms',   checked);
    onChange('privacy', checked);
    onChange('cookie',  checked);
  };

  return (
    <div className="space-y-2">
      <label className="flex items-start gap-2 text-[13px] text-gray-600 leading-snug">
        <input
          type="checkbox"
          className="mt-0.5"
          disabled={disabled}
          checked={allChecked}
          onChange={(e) => handleChange(e.target.checked)}
        />
        <span>
          Я принимаю{' '}
          <Link to={terms?.path || '#'} className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">
            {terms?.label || 'Публичная оферта'}
          </Link>
          {' '}и{' '}
          <Link to={privacy?.path || '#'} className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">
            {privacy?.label || 'Политика конфиденциальности'}
          </Link>
          {' '}и{' '}
          <Link to={cookie?.path || '#'} className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">
            {cookie?.label || 'Политика cookie'}
          </Link>
          {' '}*
        </span>
      </label>

      <p className="text-[11.5px] text-gray-400 pt-1">
        Поля со звёздочкой обязательны.
      </p>
    </div>
  );
}